import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useIntl } from 'react-intl';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type FragmentContext, type RecommendationConfig } from '../../../shared/types';
import { TrackingCategory, TrackingListName } from '../../enums';
import { relatedProductMessages as messages } from '../../i18n';
import { Headlines } from '../Headlines';
import { ProductSlider } from '../ProductSlider';

type RelatedProductsProps = {
    readonly recommendationConfig: RecommendationConfig;
    readonly lazyLoad: boolean;
};

const RelatedProducts = ({
    lazyLoad,
    recommendationConfig,
}: RelatedProductsProps): JSX.Element | null => {
    const { options } = recommendationConfig;

    const { dyRecommendations } = useFragmentContext<FragmentContext>();
    const intl = useIntl();

    const [virtualSlide, setVirtualSlide] = useState(false);

    const recommendations = dyRecommendations || [];

    useEffect(() => {
        flushSync(() => {
            setVirtualSlide(true);
        });
    }, []);

    return (
        <>
            <Headlines headline={options?.headline} subHeadline={options?.subHeadline} />
            <ProductSlider
                productItems={recommendations}
                title={options?.productSliderTitle ?? intl.formatMessage(messages.relatedProducts)}
                trackingCategory={TrackingCategory.ProductList}
                trackingListName={TrackingListName.Recommendation}
                dataTestId="related-products-slider"
                lazyLoad={lazyLoad}
                showSkeletons={!recommendations.length}
                virtualSlide={virtualSlide}
            />
        </>
    );
};

export { RelatedProducts };
